var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "preview configs bluerect" }, [
    _vm.file.type == "img" || _vm.file.type == "pdf"
      ? _c("div", { staticClass: "w2dpreview" }, [
          _c("div", { staticClass: "contentid" }, [
            _vm.contentId
              ? _c("span", [_vm._v(_vm._s(_vm.contentId))])
              : _vm._e(),
            _vm.publishDate
              ? _c("p", [_vm._v("pubblicato il " + _vm._s(_vm.publishDate))])
              : _vm._e(),
          ]),
          _c("div", [
            _c("span", { staticClass: "destination" }, [
              _vm._v(">> " + _vm._s(_vm.destination)),
            ]),
          ]),
          _c("div", [
            _c("h1", {
              staticClass: "headline",
              domProps: { innerHTML: _vm._s(_vm.file.headline) },
            }),
          ]),
          _c("img", {
            staticClass: "thumbnailpreview",
            attrs: { src: _vm.file.imgsrc },
          }),
          _c("div", {
            staticClass: "caption",
            domProps: { innerHTML: _vm._s(_vm.file.body) },
          }),
        ])
      : _vm.file.type == "url" || _vm.file.type == "any"
      ? _c(
          "div",
          { staticClass: "w2dpreview" },
          [
            _c("div", { staticClass: "contentid" }, [
              _vm.contentId
                ? _c("span", [_vm._v(_vm._s(_vm.contentId))])
                : _vm._e(),
              _vm.publishDate
                ? _c("p", [_vm._v("pubblicato il " + _vm._s(_vm.publishDate))])
                : _vm._e(),
            ]),
            _c("div", [
              _c("span", { staticClass: "destination" }, [
                _vm._v(">> " + _vm._s(_vm.destination)),
              ]),
            ]),
            _c("div", [
              _c("h1", {
                staticClass: "headline",
                domProps: { innerHTML: _vm._s(_vm.file.headline) },
              }),
            ]),
            _c("div", [
              _c("h2", {
                staticClass: "lead",
                domProps: { innerHTML: _vm._s(_vm.file.lead) },
              }),
            ]),
            _vm.validUrl
              ? [
                  _c("img", {
                    staticClass: "thumbnailpreview",
                    attrs: { src: _vm.file.imgsrc },
                  }),
                ]
              : _vm._e(),
            _c("div", {
              staticClass: "body",
              domProps: { innerHTML: _vm._s(_vm.file.body) },
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }